import cn from 'classnames';
import icons from './icons/icons';
import styles from './styles.scss';
import { createElement } from 'react';

const ICONS = [
  'icon-home',
  'icon-menu',
  'icon-mail',
  'icon-star',
  'icon-tbphone',
  'icon-phone',
  'icon-section-n',
  'icon-section-o',
  'icon-section-p',
  'icon-section-q',
  'icon-section-r',
  'icon-section-u',
  'icon-section-y',
  'icon-checkmark',
  'icon-tall-arrow',
  'icon-basket-uw',
  'icon-search-uw',
  'icon-gop-cart',
  'icon-gop-chat',
  'icon-gop-location',
  'icon-check',
  'icon-warning',
  'icon-calendar',
  'icon-gop-shipping',
  'icon-gop-sample',
  'icon-gop-fourteen-days',
  'icon-gop-facebook',
  'icon-gop-linkedin',
  'icon-gop-instagram',
  'icon-gop-pinterest'
] as const;

export type Icons = (typeof ICONS)[number];

export const isIconName = (iconName: string): iconName is Icons =>
  ICONS.includes(iconName as Icons);

type AppearanceType = 'flip-45' | 'flip-90' | 'flip-180' | 'flip-270' | 'normal';

type Size = 'tiny' | 'small' | 'medium' | 'large' | 'xl' | 'xl2' | 'mega';

export interface IconProps {
  size?: Size;
  appearance?: AppearanceType;
  className?: string;
  inline?: boolean;
  fill?: boolean;
}

type OwnProps = IconProps & {
  icon: Icons;
};

export default ({ icon, size, className, appearance, inline = false, ...props }: OwnProps) =>
  createElement(
    inline ? 'span' : 'div',
    {
      ...props,
      className: cn(styles.baseLegacy, className, {
        [styles.tiny]: size === 'tiny',
        [styles.small]: size === 'small',
        [styles.medium]: size === 'medium',
        [styles.large]: size === 'large',
        [styles.mega]: size === 'mega',
        [styles.flip90]: appearance === 'flip-90',
        [styles.flip180]: appearance === 'flip-180',
        [styles.flip270]: appearance === 'flip-270'
      })
    },
    icons[icon]
  );

export { IconBirthday } from './birthday';
export { IconBbuLocation } from './iconBbuLocation';
export { IconMenu } from './iconMenu';
export { IconPhoneCalling } from './iconPhoneCalling';
export { IconPlus } from './iconPlus';
export { IconTag } from './iconTag';
export { IconUwPayments } from './iconUwPayments';
export { IconUwPricerunner } from './iconUwPricerunner';
export { IconVoteDown } from './iconVoteDown';
export { IconVoteReport } from './iconVoteReport';
export { IconVoteUp } from './iconVoteUp';
export { IconPdf } from './pdf';
export { IconCheckmark } from './themes/BGH-RD3/iconCheckmark';
export { IconArrow } from './themes/BGH/iconArrow';
export { IconBasket } from './themes/BGH/iconBasket';
export { IconFavourite } from './themes/BGH/iconFavourite';
export { IconHeart } from './themes/BGH/iconHeart';
export { IconMail } from './themes/BGH/iconMail';
export { IconPhone } from './themes/BGH/iconPhone';
export { IconSearch } from './themes/BGH/iconSearch';
export { IconStar } from './themes/BGH/iconStar';
export { IconStores } from './themes/BGH/iconStores';
export { IconWatch } from './iconWatch';
export { IconChartUp } from './iconChartUp';
export { IconThumbsUp } from './iconThumbsUp';
export { IconEye } from './iconEye';
export { IconHelpCenterOpt } from './themes/BGH-RD3/IconHelpCenterOpt';
// paymentTypes
export { IconAmex } from './paymentMethods/iconAmex';
export { IconKlarna } from './paymentMethods/iconKlarna';
export { IconMasterCard } from './paymentMethods/iconMasterCard';
export { IconSvea } from './paymentMethods/iconSvea';
export { IconSwish } from './paymentMethods/iconSwish';
export { IconVisa } from './paymentMethods/iconVisa';
export { IconVipps } from './paymentMethods/iconVipps';
